module.exports = __webpack_public_path__ + "img/gjj-android.2e53a503.png";